import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidenavStateService {
  readonly collapsed = signal(false);
}
